import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { getPositions } from 'store/entities/configuration/configurationAction';
import { PayCodesTable } from 'modules/settings/submodules/clients/payCodes/components/PayCodesTable/PayCodesTable';

export const ClientPayCodesList = () => {
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(getPositions.init());
    }, [dispatch]);

    return (
        <PayCodesTable />
    );
};
